import React, { useEffect } from 'react'
import { Link } from 'react-router-dom'
import Footer from '../../componets/General/Footer'
import NavBar from '../../componets/General/NavBar'
import '../../style/botonProyect.css'
const Boton = () =>{
    
    useEffect(()=>{
        window.scrollTo(0,0);
    },[])

    return (
        <>
            <NavBar/>
            <div className =" my-5">
                <Link className="btn btnP "  to="/">
                    <span></span>
                    <span></span>
                    <span></span>
                    <span></span>
                    HOME
                </Link>
            </div>
            <Footer/>
        </>
    )
}

export default Boton